module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12 col-xs-12 wrapper-box"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-8 col-lg-7 col-xs-12 remove-margins"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterProfile.Title),
      expression: "sitterProfile.Title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Title: e.g your trusted dog buddy!"
    },
    domProps: {
      "value": (_vm.sitterProfile.Title)
    },
    on: {
      "change": function($event) {
        _vm.somethingChanged()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sitterProfile, "Title", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("introduce yourself and let Pet parents know you better, take your time tell them why you are their best sitter")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterProfile.AboutMe),
      expression: "sitterProfile.AboutMe"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "5",
      "placeholder": "Describe yourself and add anything you want about your work and prevoius pet experiences"
    },
    domProps: {
      "value": (_vm.sitterProfile.AboutMe)
    },
    on: {
      "change": function($event) {
        _vm.somethingChanged()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sitterProfile, "AboutMe", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('UploadBackgroundPhoto')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-xs-12 remove-margins"
  }, [_vm._m(3), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("To make your profile standout upload 3 or more photos.")]), _vm._v(" "), _c('div', {
    staticClass: "images-custom-container"
  }, [_vm._l((_vm.sitterPhotoList), function(photo, index) {
    return (_vm.sitterPhotoList != 0) ? _c('div', {
      staticClass: "image-class"
    }, [_c('ProfilePhotoView', {
      key: photo.SitterPhotoId,
      attrs: {
        "photoIdProp": photo.SitterPhotoId,
        "index": index
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "close",
      on: {
        "click": function($event) {
          _vm.deleteImage(photo)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "title": "Delete this photo"
      }
    })])], 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "image-class"
  }, [_c('UploadAddMore')], 1)], 2)]), _vm._v(" "), (_vm.sitterProfile) ? _c('div', {
    staticClass: "col-sm-8 col-xs-12 remove-margins"
  }, [(_vm.sitterProfile.HomeDetailDto) ? _c('div', [_c('h3', {
    staticStyle: {
      "margin-bottom": "0px",
      "padding-bottom": "0px"
    }
  }, [_vm._v("Home Details")]), _vm._v(" "), _c('li', {
    staticClass: "checkbox",
    staticStyle: {
      "margin-top": "0px",
      "padding-top": "0px"
    }
  }, [_c('label', {
    staticClass: "h5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterProfile.HomeDetailDto.IsHasChildren),
      expression: "sitterProfile.HomeDetailDto.IsHasChildren"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sitterProfile.HomeDetailDto.IsHasChildren) ? _vm._i(_vm.sitterProfile.HomeDetailDto.IsHasChildren, null) > -1 : (_vm.sitterProfile.HomeDetailDto.IsHasChildren)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.sitterProfile.HomeDetailDto.IsHasChildren,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sitterProfile.HomeDetailDto.IsHasChildren = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sitterProfile.HomeDetailDto.IsHasChildren = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.sitterProfile.HomeDetailDto, "IsHasChildren", $$c)
        }
      }, function($event) {
        _vm.somethingChanged()
      }]
    }
  }), _vm._v("\n                         Children under 10 years at Home")])]), _vm._v(" "), _c('li', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "h5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterProfile.HomeDetailDto.IsSmokeFree),
      expression: "sitterProfile.HomeDetailDto.IsSmokeFree"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sitterProfile.HomeDetailDto.IsSmokeFree) ? _vm._i(_vm.sitterProfile.HomeDetailDto.IsSmokeFree, null) > -1 : (_vm.sitterProfile.HomeDetailDto.IsSmokeFree)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.sitterProfile.HomeDetailDto.IsSmokeFree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sitterProfile.HomeDetailDto.IsSmokeFree = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sitterProfile.HomeDetailDto.IsSmokeFree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.sitterProfile.HomeDetailDto, "IsSmokeFree", $$c)
        }
      }, function($event) {
        _vm.somethingChanged()
      }]
    }
  }), _vm._v("\n                         Smoke Free Household")])]), _vm._v(" "), _c('li', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "h5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterProfile.HomeDetailDto.IsHasDog),
      expression: "sitterProfile.HomeDetailDto.IsHasDog"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sitterProfile.HomeDetailDto.IsHasDog) ? _vm._i(_vm.sitterProfile.HomeDetailDto.IsHasDog, null) > -1 : (_vm.sitterProfile.HomeDetailDto.IsHasDog)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.sitterProfile.HomeDetailDto.IsHasDog,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sitterProfile.HomeDetailDto.IsHasDog = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sitterProfile.HomeDetailDto.IsHasDog = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.sitterProfile.HomeDetailDto, "IsHasDog", $$c)
        }
      }, function($event) {
        _vm.somethingChanged()
      }]
    }
  }), _vm._v("\n                         I have resident Dog at home")])]), _vm._v(" "), _c('li', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "h5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterProfile.HomeDetailDto.IsHasCat),
      expression: "sitterProfile.HomeDetailDto.IsHasCat"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sitterProfile.HomeDetailDto.IsHasCat) ? _vm._i(_vm.sitterProfile.HomeDetailDto.IsHasCat, null) > -1 : (_vm.sitterProfile.HomeDetailDto.IsHasCat)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.sitterProfile.HomeDetailDto.IsHasCat,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sitterProfile.HomeDetailDto.IsHasCat = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sitterProfile.HomeDetailDto.IsHasCat = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.sitterProfile.HomeDetailDto, "IsHasCat", $$c)
        }
      }, function($event) {
        _vm.somethingChanged()
      }]
    }
  }), _vm._v("\n                         I have resident Cat at home")])]), _vm._v(" "), _c('h3', [_vm._v("Home Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterProfile.HomeDetailDto.HomeType),
      expression: "sitterProfile.HomeDetailDto.HomeType"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sitterProfile.HomeDetailDto, "HomeType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.somethingChanged()
      }]
    }
  }, _vm._l((_vm.homeTypes), function(homeType) {
    return _c('option', {
      domProps: {
        "value": homeType.value
      }
    }, [_vm._v("\n                        " + _vm._s(homeType.text) + "\n                    ")])
  }))]) : _vm._e(), _vm._v(" "), _vm._m(4), _vm._v(" "), (_vm.citiesList) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterProfile.SitterLocationDto.CityId),
      expression: "sitterProfile.SitterLocationDto.CityId"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sitterProfile.SitterLocationDto, "CityId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.somethingChanged()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "null",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v(_vm._s(_vm.selectCityComp))]), _vm._v(" "), _vm._l((_vm.citiesList), function(city) {
    return _c('option', {
      domProps: {
        "value": city.CityId
      }
    }, [_vm._v("\n                        " + _vm._s(city.CityName) + "\n                    ")])
  })], 2) : _vm._e(), _vm._v(" "), ((!_vm.areasList || _vm.areasList.length == 0)) ? _c('div', {
    staticClass: "form-location",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.areasList) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterProfile.SitterLocationDto.AreaId),
      expression: "sitterProfile.SitterLocationDto.AreaId"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "5px"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.sitterProfile.SitterLocationDto, "AreaId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.somethingChanged()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "null",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Select your neighbor")]), _vm._v(" "), _vm._l((_vm.areasList), function(area) {
    return _c('option', {
      domProps: {
        "value": area.AreaId
      }
    }, [_vm._v("\n                        " + _vm._s(area.AreaName) + "\n                    ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-10 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "0px",
      "padding": "0px"
    }
  }, [_c('button', {
    staticClass: "btn  large-pad btn-success btn-block btn-lg",
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "0px"
    },
    on: {
      "click": function($event) {
        _vm.updateSitterProfile()
      }
    }
  }, [_vm._v(_vm._s(_vm.saveChanges))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("Profile Title "), _c('span', {
    staticClass: "red-star",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "Required to publish your profile"
    }
  }, [_vm._v("★")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("Info about yourself "), _c('span', {
    staticClass: "red-star",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "Required to publish your profile"
    }
  }, [_vm._v("★")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("Background Image "), _c('span', {
    staticClass: "red-star",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "Required to publish your profile"
    }
  }, [_vm._v("★")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticStyle: {
      "margin-bottom": "0px",
      "margin-top": "0px"
    }
  }, [_vm._v("Profile Image, minimum 1 personal "), _c('span', {
    staticClass: "red-star",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "Required to publish your profile"
    }
  }, [_vm._v("★")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("Location Details "), _c('span', {
    staticClass: "red-star",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "Required to publish your profile"
    }
  }, [_vm._v("★")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control input-text"
  }, [_c('option', {
    attrs: {
      "value": "null",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Select your neighbor")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e7b200e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sitters/Profile/AboutMe.vue
// module id = 606
// module chunks = 2